export default class ListingAnchors extends HTMLElement {
    static CALL_EVENT = 'onInview';

    constructor(m) {
        super(m);

        // Binding
        this.onUpdateIndicator = this.onUpdateIndicator.bind(this);

        // UI
        this.$links = Array.from(this.querySelectorAll('[data-links]'));
        this.$stickyNav = this.querySelector('[data-sticky-nav]');
        this.$stickyNavLinks = Array.from(this.$stickyNav.querySelectorAll('[data-links]'));

        // Data
        this.uid = this.dataset.uid;

        let cumulativeOffset = 0;
        this.metrics = this.$stickyNavLinks.map((link) => {
            cumulativeOffset = cumulativeOffset + link.parentNode.offsetWidth;
            return cumulativeOffset;
        });
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        window.addEventListener(`${ListingAnchors.CALL_EVENT}${this.uid}`, this.onUpdateIndicator);
    }

    unbindEvents() {
        window.removeEventListener(
            `${ListingAnchors.CALL_EVENT}${this.uid}`,
            this.onUpdateIndicator
        );
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onUpdateIndicator(e) {
        const { target, way } = e.detail;

        if (way === 'enter') {
            this.$links.forEach((link) => {
                const href = link.getAttribute('href');
                if (href.includes(`#${target.id}`)) {
                    link.classList.add('is-active');
                } else {
                    link.classList.remove('is-active');
                }
            });

            this.scrollToLink(target);
        } else if (way === 'leave') {
            this.$links.forEach((link) => {
                const href = link.getAttribute('href');
                if (href.includes(`#${target.id}`)) {
                    link.classList.remove('is-active');
                }
            });
        }
    }

    scrollToLink(target) {
        const findIndex = this.$stickyNavLinks.findIndex((link) =>
            link.getAttribute('href').includes(target.id)
        );
        const link = this.$stickyNavLinks[findIndex];

        if (link) {
            this.$stickyNav.scrollTo({
                left: this.metrics[findIndex - 1] || 0,
                behavior: 'smooth'
            });
        }
    }
}
